module.exports = __webpack_public_path__ + "img/calendar-plus-red.2f06bfe2.svg";